import * as actionTypes from '../constants/actionTypes';
import * as def from '../constants/defines';
import {login} from './login';

export function switchToRegistration() {
    return {type: actionTypes.REGISTER_USER};
}

export function cancelRegistration() {
    return {type: actionTypes.CANCEL_REGISTRATION};
}

export function register(email, full_name, password) {
    return dispatch => {
        dispatch({type: actionTypes.REGISTRATION_REQUEST});
        fetch(def.REGISTRATION_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({email: email, name: full_name, password: password})
        }).then(response =>
            response.json().then(({status, data, errorCode, errors}) => {
                if (status === 'ok') {
                    const {username, password} = data.accounts.iptv;
                    dispatch({type: actionTypes.REGISTRATION_SUCCESS});
                    dispatch(login(username, password));
                } else if (status === 'error') {
                    dispatch({type: actionTypes.REGISTRATION_FAILED, errorCode: errorCode, errors: errors});
                }
        })).catch(error => dispatch({type: actionTypes.REGISTRATION_FAILED, errorCode: 404, errors: [error]}))
    }
}


// WEBPACK FOOTER //
// ./src/actions/registration.js